import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Hamburger, MonerisLogo } from '../../icons';
import colors from '../../utils/colors';
import { StyledBrand, StyledSidebarToggle, StyledAppLink } from './Brand.styles';
const { midnight, white } = colors;
const Brand = React.forwardRef(({ appName, appLinkAs, sidebarToggleAriaLabel, renderOnSidebar, toggleSidebar, ...restProps }, ref) => (_jsx(ThemeProvider, { theme: { color: renderOnSidebar ? midnight : white }, children: _jsxs(StyledBrand, { ref: ref, renderonsidebar: renderOnSidebar, ...restProps, children: [toggleSidebar && (_jsx(StyledSidebarToggle, { "aria-label": sidebarToggleAriaLabel, onClick: () => toggleSidebar(), children: _jsx(Hamburger, {}) })), _jsx(StyledAppLink, { href: '/sales', "aria-label": `Go ${appName}`, as: appLinkAs, children: _jsx(MonerisLogo, {}) })] }) })));
Brand.displayName = 'Brand';
Brand.defaultProps = {
    appName: 'Portal',
    sidebarToggleAriaLabel: 'Toggle navigation',
};
export default Brand;
